<template>
  <div class="container-fluid">
    <div id="printableArea">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body card-blue">
              <div class="button-group">
                <button class="float-right btn waves-effect waves-light btn-secondary" type="button" @click="$parent.reset()">
                  Close
                </button>
                <button class="float-right btn waves-effect waves-light btn-primary" type="button" @click="storeTemplate()">
                  Review and Save
                </button>
              </div>
              <div class="tab-content tabcontent-border p-t-20">
                <div v-for="impactArea in audit.impact_areas" :key="impactArea.impact_area" class="tab-pane active show" role="tabpanel">
                  <impact-area :impact-area="impactArea" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImpactArea from './ImpactArea.vue';
import EventBus from '@/event-bus';

export default {
  name: 'AuditTemplate',
  components: { ImpactArea },
  props: ['audit'],
  methods: {
    async storeTemplate() {
      try {
        if (this.audit) {
          EventBus.$emit('showBlockUI');
          this.audit.audit_name = this.$parent.audit_name;
          this.audit.version = this.$parent.version;
          this.audit.description = this.$parent.description;
          await this.$api.post('/audits/template', this.audit);
          this.$toastr.s('Template saved', 'Success!');
          this.$parent.template = null;
          this.$parent.reset();
          await this.$parent.getCertifications();
        }
      } catch (e) {
        console.error(e);
      } finally {
        EventBus.$emit('hideBlockUI');
      }
    }
  }

}
</script>

<style scoped>
</style>
